import React, { FC, useState } from 'react';
import ModalView from "@/components/Modal/ModalView";
import HelpView from "./Help.view";
import { ReactComponent as PhoneIcon } from "@/assets/images/svg/phone.svg";
import { useLang } from "@/hooks/useLang";

const HelpModal: FC<any> = props => {
  const { t } = useLang();

  const [loading, setLoading] = useState(false);
  const [isShowView, setIsShowView] = useState(false);

  const modalTitle = "Get Support"

  const showViewModal = (): void => {
    setIsShowView(true);
  }

  const hideViewModal = () => {
    setIsShowView(false);
  }

  return (
    <>
      <ModalView
        loading={loading}
        modalTitle={modalTitle}
        isShowModal={isShowView}
        handleHideModal={hideViewModal}
        component={HelpView}
      />

      <span style={{ cursor: "pointer" }} className="text-uppercase px-2" onClick={() => showViewModal()}>
        <PhoneIcon aria-hidden="true" className="me-1 d-none d-sm-inline-block ring-phone" style={{ width: '14px', fill: '#fff', verticalAlign: 'middle' }} />
        {t('Get Support')}
      </span>
    </>
  );
}

export default React.memo(HelpModal);
